// extracted by mini-css-extract-plugin
module.exports = {"selectedFont":"FontSizePicker__selectedFont__3E0an","labelText":"FontSizePicker__labelText__1ltiN"};